module.exports = __webpack_public_path__ + "static/media/matrix.cecb507d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/matrix.jpg
// module id = 237
// module chunks = 0